import * as React from 'react';

const SvgSuccessIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 61 60'
    width='61'
    height='60'
    {...props}
  >
    <circle cx='30.5' cy='30' r='30' fill='#FF0037' />

    <path
      d='M11.652 24.3611L0.511719 13.2208V7.91528L11.6659 19.0694L30.4992 0.5L30.5895 5.59028L11.652 24.3611Z'
      fill='#F4F2F2'
      transform='translate(15, 18)'
    />
  </svg>
);

export default SvgSuccessIcon;
